module.exports = __webpack_public_path__ + "static/img/product02.adede38f.png";